(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/views/react-container.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/views/react-container.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.my_profile_react=_svs.my_profile_react||{};
_svs.my_profile_react.templates=_svs.my_profile_react.templates||{};
svs.my_profile_react.templates.react_container = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"react-container\" class=\"bg-white f-body line-height-150 react-container\" />\n";
},"useData":true});
Handlebars.partials['svs-my_profile_react-react_container'] = svs.my_profile_react.templates.react_container;
})(svs, Handlebars);


 })(window);